import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from '../constants';
import { PreInitSettingsService } from './settings/pre-init-setting.service';

@Injectable({ providedIn: 'root' })
export class EzPassService {
  private httpClient = inject(HttpClient);
  private preInitSettingsService = inject(PreInitSettingsService);

  private get verifyUrl(): string {
    const settings = this.preInitSettingsService.getSettings()?.middleWare;
    return `${settings?.middlewareUrl ?? ''}${settings?.accountPath ?? ''}${AppConstants.API_ENDPOINTS.VerifySessionToken}`;
  }

  /**
   * Exchanges an EZ Pass session token for an identity token.
   * The HTTP interceptor automatically captures the `IdentityToken` response header
   * and writes it to localStorage['identity-token'] on success.
   */
  verifySession(token: string): Observable<HttpResponse<unknown>> {
    return this.httpClient.post<unknown>(this.verifyUrl, { token }, { observe: 'response' });
  }
}
